import * as React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import PublicApp from "./public";
import PrivateApp from "./private";

class App extends React.Component {

  public render() {

    const NoMatchPage = (location: any) => {
      let doc = document.getElementById("overlayFix");
      if( doc ) doc.style.display = "none";
      return (
        <div className="noMatchPage">
          <h1>
            404
          </h1>
        </div>
      );
    }

    const logoutPage = (location: any) => {
      let doc = document.getElementById("overlayFix");
      if( doc ) doc.style.display = "none";
      return (
        <div className="logoutPage">
          <h1>
            DRRIPBAL Logout
          </h1>
          <p>You have successfully logged out of DRRIPBAL</p>
        </div>
      );
    }

    const helpPage = (location: any) => {
      let doc = document.getElementById("overlayFix");
      if( doc ) doc.style.display = "none";
      return (
        <div className="helpPage">
          <h1>
            DRRIPBAL Help
          </h1>
          <p>No Content</p>
        </div>
      );
    }

    return (
      <Router>
        <Switch>
          <Route exact path="/drripbal/" component={PublicApp} />
          <Route exact path="/drripbal/fdic" ><Redirect to="/drripbal/fdic/unpublish"/></Route>
          <Route path="/drripbal/fdic/bank/:id" component={PrivateApp} />
          <Route path="/drripbal/fdic/:type" component={PrivateApp} />
          <Route path="/drripbal/bank/:id" component={PublicApp} />
          <Route exact path="/drripbal/logout"component={logoutPage} />
          <Route exact path="/drripbal/help"component={helpPage} />
          <Route component={NoMatchPage} />
        </Switch>
      </Router>
    );
  }
}

export default App;
